import React, { useState } from "react"
import { Button } from "react-bootstrap"

import { isLTPM } from "../../../../../components/shared_components_registration"

const registration = {
  color_input_placeholder: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "graphing.color.picker.placeholder",
        })
      : "e.g. red or rgb(255,2,2)",
  search: (intl) => (isLTPM ? intl.formatMessage({ id: "general.search" }) : "Search"),
}

const color_picker_colors = [
  "rgb(137,69,59)",
  "rgb(76,103,153)",
  "rgb(128,145,63)",
  "rgb(183,124,56)",
  "rgb(109,85,136)",
  "rgb(121,126,186)",
  "rgb(216,36,31)",
  "rgb(23,118,182)",
  "rgb(36,162,33)",
  "rgb(255,127,0)",
  "rgb(149,100,191)",
  "rgb(0,190,209)",
  "rgb(163,41,12)",
  "rgb(112,168,196)",
  "rgb(94,160,77)",
  "rgb(182,121,52)",
  "rgb(96,56,158)",
  "rgb(62,111,189)",
  "rgb(130,63,54)",
  "rgb(48,73,124)",
  "rgb(98,176,80)",
  "rgb(224,154,74)",
  "rgb(174,53,203)",
  "rgb(102,132,190)",
  "rgb(192, 0, 0)",
  "rgb(68, 114, 196)",
  "rgb(146, 208, 80)",
  "rgb(255, 192, 0)",
  "rgb(229,116,195)",
  "rgb(162,142,194)",
  "rgb(141,86,73)",
  "rgb(100,170,80)",
  "rgb(188,191,0)",
  "rgb(255,250,90)",
  "rgb(128, 128, 128)",
  "rgb(0,0,0)",
]

export function get_color_picker_color_grid(box, boxDiam) {
  let columns = Math.floor(box.width / boxDiam)
  let rows = Math.floor(box.height / boxDiam)
  let boxArray = []
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < columns; col++) {
      let currentIndex = row * columns + col
      if (currentIndex > color_picker_colors.length - 1) {
        break
      }
      let x1 = col * boxDiam
      let y1 = row * boxDiam
      let content = {
        idx: currentIndex,
        x: x1,
        y: y1,
        diameter: boxDiam,
        color: color_picker_colors[currentIndex],
      }
      boxArray.push(content)
    }
  }
  return [boxArray, box.width, box.height]
}

export default function TrendColorEditor({
  box = {
    height: 180,
    width: 180,
    margin: 5,
  },
  boxDiam = 30,
  colorSelect,
  intl,
  rowStyle = {},
}) {
  const [boxArray, boxWidth, boxHeight] = get_color_picker_color_grid(box, boxDiam)
  const [color, setColor] = useState("")

  const chooseColor = (color) => {
    let color_holder = new Option().style
    color_holder.color = color.toLowerCase()

    if (color_holder.color.split(" ").join("") === color.split(" ").join("")) {
      colorSelect(color)
    }
  }

  return (
    <>
      <svg
        width={boxWidth}
        height={boxHeight}
        style={{
          display: "block",
          margin: "auto",
          marginBottom: "20px",
          marginTop: "20px",
        }}
      >
        {boxArray.map((box) => (
          <rect
            key={box.idx}
            values={box.color}
            className={"colorSelect"}
            onClick={(e) => {
              chooseColor(box.color)
            }}
            x={box.x}
            y={box.y}
            width={box.diameter}
            height={box.diameter}
            stroke={box.color}
            fill={box.color}
          />
        ))}
      </svg>
      <div style={rowStyle}>
        <input
          style={{ width: "100%" }}
          type={"text"}
          value={color}
          placeholder={registration["color_input_placeholder"](intl)}
          onChange={(e) => {
            e.preventDefault()
            setColor(e.target.value)
          }}
        />
        <Button
          variant={"outline-primary"}
          className={"btn btn-sm"}
          style={{ marginLeft: "auto" }}
          onClick={(e) => {
            e.preventDefault()
            if (color !== "") {
              chooseColor(String(color))
              setColor("")
            }
          }}
        >
          {registration["search"](intl)}
        </Button>
      </div>
    </>
  )
}
